import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbHighlight } from './highlight';
import { NgbTypeaheadWindow } from './typeahead-window';
import { NgbTypeahead } from './typeahead';

export { NgbHighlight } from './highlight';
export { NgbTypeaheadWindow } from './typeahead-window';
export { NgbTypeaheadConfig } from './typeahead-config';
export { NgbTypeahead, NgbTypeaheadSelectItemEvent } from './typeahead';

@NgModule({
	declarations: [NgbTypeahead, NgbHighlight, NgbTypeaheadWindow],
	exports: [NgbTypeahead, NgbHighlight],
	imports: [CommonModule],
})
export class NgbTypeaheadModule {}
